export async function consumeSSE(
  response: Response,
  onEvent: (id: string, event: string, data: any) => void,
  onCancel?: () => void
) {
  if (!response.body) {
    throw new Error("No response body");
  }

  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";

  try {
    while (true) {
      const { done, value } = await reader.read();
      if (done) break;

      buffer += decoder.decode(value, { stream: true });
      
      const parts = buffer.split('\n\n');
      // The last part is incomplete, keep it in the buffer
      buffer = parts.pop() || "";

      for (const part of parts) {
        if (!part.trim()) continue;
        
        const lines = part.split('\n');
        let id = "";
        let event = "message";
        let data = "";

        for (const line of lines) {
          if (line.startsWith("id: ")) {
            id = line.substring(4);
          } else if (line.startsWith("event: ")) {
            event = line.substring(7);
          } else if (line.startsWith("data: ")) {
            data += line.substring(6);
          }
        }
        
        if (data) {
          try {
            const parsedData = JSON.parse(data);
            onEvent(id, event, parsedData);
          } catch (e) {
            console.error("Failed to parse SSE JSON data", data, e);
          }
        }
      }
    }
  } catch (err) {
    if (err instanceof DOMException && err.name === "AbortError") {
      if (onCancel) onCancel();
    } else {
      throw err;
    }
  } finally {
    reader.releaseLock();
  }
}
